// Ошибка бэкенда в общей обёртке utils.api.error_response.
interface ErrorEnvelope {
  error: { code?: string; user_message: string };
}

function isErrorEnvelope(data: unknown): data is ErrorEnvelope {
  if (typeof data !== 'object' || data === null || !('error' in data)) return false;
  const { error } = data;
  return (
    typeof error === 'object' && error !== null
    && 'user_message' in error && typeof error.user_message === 'string'
  );
}

// Текст ошибки для пользователя из ошибки RTK Query (`{ status, data }`).
// Сетевые сбои и ответы без обёртки получают fallback: сырой текст DRF или
// fetch пользователю ничего не скажет.
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (typeof error === 'object' && error !== null && 'data' in error && isErrorEnvelope(error.data)) {
    return error.data.error.user_message || fallback;
  }
  return fallback;
}

// HTTP-статус ошибки RTK Query; null — сетевой сбой или не ошибка запроса.
export function getApiErrorStatus(error: unknown): number | null {
  if (typeof error === 'object' && error !== null && 'status' in error && typeof error.status === 'number') {
    return error.status;
  }
  return null;
}
